module.exports = __webpack_public_path__ + "static/media/kaixuan.5690b17.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/nyf/mp3/kaixuan.mp3
// module id = ckjy
// module chunks = 1 12